import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import PageContainer from './containers/PageContainer';
import QuickViewProvider from '../../components/QuickView';

import { rootNode, defaultState } from './configs';
import reducer from './reducers';
import createStore from '../../store/create-store';

const store = createStore(reducer, defaultState);

const ReportsExportsPage = () => (
  <Provider store={store}>
    <QuickViewProvider>
      <PageContainer />
    </QuickViewProvider>
  </Provider>
);

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<ReportsExportsPage />);
});
